// extracted by mini-css-extract-plugin
module.exports = {"rfoOffersWrapper":"RfoOffers_rfoOffersWrapper__wdoDf","offerTable":"RfoOffers_offerTable__2XXQ5"};